import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isBn, isNumber, isString, isU8a } from '@polkadot/util';
import { decodeAddress } from '@polkadot/util-crypto';
import { Enum } from "../codec/Enum.mjs";
import { GenericAccountId } from "./AccountId.mjs";
import { GenericAccountIndex } from "./AccountIndex.mjs";

function decodeMultiU8a(value) {
  if (isU8a(value) && value.length <= 32) {
    if (value.length === 32) {
      return {
        id: value
      };
    } else if (value.length === 20) {
      return {
        Address20: value
      };
    }
  }

  return value;
}

function decodeMultiAny(registry, value) {
  if (value instanceof GenericMultiAddress) {
    return value;
  } else if (value instanceof GenericAccountId) {
    return {
      Id: value
    };
  } else if (value instanceof GenericAccountIndex || isNumber(value) || isBn(value)) {
    return {
      Index: registry.createType('Compact<AccountIndex>', value)
    };
  } else if (isString(value)) {
    return decodeMultiU8a(decodeAddress(value.toString()));
  }

  return decodeMultiU8a(value);
}

export var GenericMultiAddress =
/*#__PURE__*/
function (_Enum) {
  _inherits(GenericMultiAddress, _Enum);

  function GenericMultiAddress(registry, value) {
    _classCallCheck(this, GenericMultiAddress);

    return _possibleConstructorReturn(this, _getPrototypeOf(GenericMultiAddress).call(this, registry, {
      Id: 'AccountId',
      Index: 'Compact<AccountIndex>',
      Raw: 'Bytes',
      // eslint-disable-next-line sort-keys
      Address32: 'H256',
      // eslint-disable-next-line sort-keys
      Address20: 'H160'
    }, decodeMultiAny(registry, value)));
  }
  /**
   * @description Returns the string representation of the value
   */


  _createClass(GenericMultiAddress, [{
    key: "toString",
    value: function toString() {
      return this.value.toString();
    }
  }]);

  return GenericMultiAddress;
}(Enum);